import { Skeleton as SkeletonPrimitive } from '@/components/ui/skeleton'

const COLUMN_KEYS = Array.from({ length: 3 }, (_, i) => `column-${i}`)
const INDICATOR_KEYS = Array.from({ length: 6 }, (_, i) => `indicator-${i}`)

export function DistributionPending() {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-8 @sm:px-6 @lg:px-8">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <SkeletonPrimitive className="size-10 rounded-xl" />
          <SkeletonPrimitive className="h-6 w-40" />
        </div>
        <SkeletonPrimitive className="h-4 w-72" />
      </div>

      <div className="flex flex-col flex-wrap items-stretch gap-2 @sm:flex-row @sm:items-center @sm:gap-3">
        <SkeletonPrimitive className="h-9 w-52 rounded-lg" />
        <SkeletonPrimitive className="h-9 w-52 rounded-lg" />
      </div>

      <div className="grid gap-6 @2xl:grid-cols-3">
        {COLUMN_KEYS.map((colKey) => (
          <div key={colKey} className="flex flex-col gap-1">
            <div className="pb-2">
              <SkeletonPrimitive className="h-4 w-32" />
            </div>
            <div className="flex flex-col gap-1">
              {INDICATOR_KEYS.map((indKey) => (
                <div key={indKey} className="bg-card flex flex-col gap-2 rounded-lg border p-3">
                  <div className="flex items-start justify-between gap-3">
                    <SkeletonPrimitive className="h-4 w-28" />
                    <SkeletonPrimitive className="h-5 w-14 rounded-full" />
                  </div>
                  <SkeletonPrimitive className="h-1.5 w-full rounded-full" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
